import {
  fetchAll,
  fetchFiltered,
  add,
  edit,
  show
} from '@/api/status'

const state = {
  all: [],
  isLoading: false,
  statusById: null
}

const actions = {
  cleanState ({ commit }) {
    commit('cleanState')
  },

  async fetchAll ({ dispatch, commit }) {
    try {
      const status = await fetchAll()
      commit('setAll', status)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchById ({ dispatch, commit }, id) {
    try {
      const status = await show(id)
      commit('setStatusById', status)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchFiltered ({ dispatch, commit }, queriesParams) {
    try {
      const status = await fetchFiltered(queriesParams)
      commit('setAll', status)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async edit ({ dispatch, commit }, { id, data }) {
    commit('setLoading', true)
    try {
      await edit(id, data)
      return true
    } catch (e) {
      const msg = e.message === 'alreadyExists'
        ? { message: 'Status já cadastrado!' }
        : e

      dispatch('notify/error', msg, { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  },

  async create ({ dispatch, commit }, status) {
    commit('setLoading', true)
    try {
      await add(status)
      return true
    } catch (e) {      
      const msg = e.message === 'alreadyExists'
        ? { message: 'Status já cadastrado!' }
        : e

      dispatch('notify/error', msg, { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  }
}

const mutations = {
  setAll (state, status) {
    state.all = status
  },

  setStatusById (state, status) {
    state.statusById = status
  },

  setLoading (state, isLoading) {
    state.isLoading = isLoading
  },

  cleanState (state) {
    state.all = []
    state.isLoading = false
    state.statusById = null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}